import React, { useMemo } from 'react';
import HistoryCard from './HistoryCard';
import Organization from 'infrastructure/Organization';
import { useGetRoleplayHistoryQuery } from 'features/roleplay/Roleplay.queries';
import styles from './History.module.scss';
import { FeatureFlag } from 'controllers/_exports';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';

const History = () => {
  const { selectedDateFilterRoleplay } = useRoleplayStore();
  const { data } = useGetRoleplayHistoryQuery({
    enabled: Organization.isRep(),
    time: FeatureFlag.enabled('ROLEPLAY_FILTERS') ? selectedDateFilterRoleplay.slug : 'all-time',
  });

  //Determinate "Recently added"
  const itemsToday = useMemo(() => {
    if (!data) return [];
    const today = new Date().toISOString().split('T')[0];
    return data.filter((item) => new Date(item?.updated_at).toISOString().split('T')[0] === today);
  }, [data]);

  const mostRecentToday = useMemo(() => {
    return [...itemsToday].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0];
  }, [itemsToday]);

  if (!Organization.isRep()) return null;
  else if (!data?.length > 0) {
    return (
      <>
        <h1 className={styles.historyTitle}>History</h1>
        <p className={styles.message}>Your roleplay history will appear here.</p>
      </>
    );
  }

  return (
    <div>
      <h1 className={styles.historyTitle}>History</h1>
      <div className={styles.container}>
        {data.map((roleplay) => (
          <HistoryCard
            data={roleplay}
            key={roleplay?.uuid}
            isNew={roleplay?.uuid === mostRecentToday?.uuid}
          />
        ))}
      </div>
    </div>
  );
};

export default History;
